import { gates } from '../../constants/gates';
import { scopes } from '../../constants/scopes';
export const useEnrichmentActionPolicies = ({
  hasGate,
  hasScope
}) => {
  // Enrichment Access
  const hasAccessEnrichment = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.DATA_ENRICHMENT_ACCESS));
  const hasAccessEnrichmentPlatform = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS));

  // Data Agent Access
  const hasDataAgentAccess = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.DATA_AGENT_ACCESS));
  const hasDataAgentPlatformAccess = !!(hasScope !== null && hasScope !== void 0 && hasScope(scopes.DATA_AGENT_PLATFORM_ACCESS));

  /**
   * @todo remove these once data agent is fully ungated and
   * all call sites have been update to remove references
   */
  const showEnrichmentActions = true;
  const showSmartPropertiesActions = true;
  const showSmartFillBatch = showSmartPropertiesActions;
  const showSmartFillList = showSmartPropertiesActions;
  const showSmartFillContact = showSmartPropertiesActions && (hasGate === null || hasGate === void 0 ? void 0 : hasGate(gates.SMART_PROPERTIES_CONTACT));
  return {
    canUpgrade: !hasAccessEnrichmentPlatform,
    canUpgradeDataAgent: !hasDataAgentPlatformAccess,
    enrichmentIcon: 'breezeSingleStar',
    isDisabled: !hasAccessEnrichment,
    isDataAgentDisabled: !hasDataAgentAccess || !hasDataAgentPlatformAccess,
    showEnrichmentActions,
    showSmartPropertiesActions,
    showSmartFillBatch,
    showSmartFillContact,
    showSmartFillList
  };
};